import PropTypes from "prop-types";

/**
 * PropTypes for DropdownMenu component
 *
 * @property {Array<Object>} [options] - Menu option objects with name, to, icon, redirect
 * @property {function} [onClicked] - Callback when menu option selected
 * @property {string} [direction] - Position direction (top or bottom)
 * @property {string} [className] - Additional CSS classes for trigger
 * @property {boolean} [horizontalIcon] - Show horizontal vs vertical dots icon
 * @property {string} [dropdownMenuContentClass] - Additional CSS classes for menu content
 */
export const dropdownMenuPropTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      to: PropTypes.string,
      icon: PropTypes.node,
      redirect: PropTypes.bool,
    })
  ),
  onClicked: PropTypes.func,
  direction: PropTypes.oneOf(["top", ""]),
  className: PropTypes.string,
  horizontalIcon: PropTypes.bool,
  dropdownMenuContentClass: PropTypes.string,
};
